import { z } from 'zod';
/**
 * Blocking a player (ADR 0076): asked by name, from the player menu, the
 * friends window or `/bloquer`, even of someone who is not in the game. The
 * server keeps the list and stops the blocked player's private lines and
 * invitations; the client hides their lines on the public channels.
 */
/** A character's blocked players at most. */
export const BLOCKS_MAX = 100;
const CharacterIdSchema = z.string().min(1).max(64);
export const BlockPlayerMessageSchema = z.object({ name: z.string().trim().min(1).max(32) });
export const UnblockPlayerMessageSchema = z.object({ characterId: CharacterIdSchema });
export const BlockedPlayerSchema = z.object({ id: CharacterIdSchema, name: z.string().min(1) });
/** The whole list, sent when the character comes in and after every change. */
export const BlocksStateSchema = z.object({
    blocked: z.array(BlockedPlayerSchema).max(BLOCKS_MAX),
});
export const BLOCK_REFUSALS = [
    'invalid',
    /** No character of that name. */
    'not-found',
    'self',
    'already-blocked',
    'not-blocked',
    'full',
];
export const BlockRejectedSchema = z.object({ reason: z.enum(BLOCK_REFUSALS) });
//# sourceMappingURL=blocks.js.map